import React, { useEffect } from 'react'
import Pagination from '@material-ui/lab/Pagination'
import styled from 'styled-components'
import { useSelector } from 'react-redux'
export default function PaginationControlled({
  total,
  handlePagination,
  query,
}) {
  const { parent, id } = useSelector(state => state.categories)
  const [page, setPage] = React.useState(1)
  const handleChange = (event, value) => {
    setPage(value)
    handlePagination(value)
  }
  useEffect(() => {
    setPage(1)
  }, [query, parent, id])
  return (
    <Wrapper>
      <Pagination count={total} page={page} onChange={handleChange} />
    </Wrapper>
  )
}
const Wrapper = styled.div`
  margin-top: 20px;
`
